import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Header from '../Header';
import Row from '../Row';
import Col from '../Col';
import Link from '../Link';
import Box from '../Box';
import Disclaimer from '../../others/Disclaimer/Disclaimer';
import Icon from '../Icon';

export interface Props {
  showTitle: boolean;
  showSubTitle: boolean;
  showIconTitle?: boolean;
  showHeaderLink: boolean;
  titleKey: string;
  defaultTitleValue?: string;
  subTitleKey: string;
  defaultSubtitleValue?: string;
  headerLinkKey: string;
  titleSettings: StyledProps<$TSFixMe>;
  headerContentSettings: StyledProps<$TSFixMe>;
  headerLinkSettings: StyledProps<$TSFixMe>;
  headerLinkContentSettings: StyledProps<$TSFixMe>;
  subHeaderContentSettings: StyledProps<$TSFixMe>;
  subTitleSettings: StyledProps<$TSFixMe>;
  iconTitleSettings: StyledProps<$TSFixMe>;
  iconTitleContainerSettings: StyledProps<$TSFixMe>;
  prePopulation: $TSFixMe;
  handleSeeMoreDeals: () => void;
  showTopDisclaimer?: boolean;
  topDisclaimerContentSettings?: $TSFixMe;
  topDisclaimer: $TSFixMe;
  titleContainerSettings: $TSFixMe;
  //Deprecated Props
  title: $TSFixMe;
  titleContentSettings: $TSFixMe;
}

export type HeaderContainerProps = StyledProps<Props>;

function HeaderContainer(props: HeaderContainerProps) {
  const {
    prePopulation = {},
    showTitle = true,
    showSubTitle = false,
    showHeaderLink = false,
    titleKey = 'cmp-container-title',
    subTitleKey = 'cmp-container-sub-title',
    headerLinkKey = 'cmp-container-header-link',
    titleSettings = {
      margin: '0',
      textAlign: 'left'
    },
    headerContentSettings,
    headerLinkSettings = {
      defaultUrl: '#',
      url: {}
    },
    headerLinkContentSettings = {
      marginBottom: '2',
      textAlign: 'right'
    },
    subHeaderContentSettings,
    subTitleSettings,
    handleSeeMoreDeals = () => {},
    defaultTitleValue = 'Trending destination',
    defaultSubtitleValue = 'Have a wonderful adventure',
    showTopDisclaimer = false,
    topDisclaimerContentSettings = {},
    topDisclaimer = {},
    titleContainerSettings = {}, //This props is from interactive Map
    //Deprecated Props
    titleContentSettings = {},
    title = {},
    showIconTitle,
    iconTitleSettings,
    iconTitleContainerSettings
  } = props;

  const { translate } = useContext(Context);
  const { siteEdition } = prePopulation;

  const { urls, defaultUrl } = headerLinkSettings;
  let headerLinkUrl = defaultUrl ?? '#';

  if (urls && urls[siteEdition]) {
    headerLinkUrl = urls[siteEdition];
  }
  return (
    <>
      {showTitle && (
        <Row
          gutters={!showIconTitle}
          {...titleContentSettings}
          {...headerContentSettings}
          {...titleContainerSettings}
        >
          {showIconTitle && (
            <Col
              {...iconTitleContainerSettings}
              cmp-styles={{
                flex: '0 0 3%',
                width: 'fit-content',
                'margin-right': '5px',
                ...iconTitleContainerSettings['cmp-styles']
              }}
            >
              <Icon
                ariaHidden
                // icon="keyboard_arrow_down"
                size={32}
                {...iconTitleSettings}
              />
            </Col>
          )}
          <Col sm={showIconTitle ? 11 : 12}>
            <Header
              tag="h2"
              dataTestId="headerTitle"
              fontSize="6"
              floatLeft
              content={translate(titleKey, defaultTitleValue)}
              id="best-fares-heading"
              {...title}
              {...titleSettings}
            />
          </Col>
        </Row>
      )}
      {showSubTitle && (
        <Row {...subHeaderContentSettings}>
          <Col sm={12}>
            <Header
              tag="h3"
              fontSize="4"
              floatLeft
              content={translate(subTitleKey, defaultSubtitleValue)}
              {...subTitleSettings}
            />
          </Col>
        </Row>
      )}
      {showHeaderLink && (
        <Row {...headerLinkContentSettings}>
          <Col>
            <Link
              href={headerLinkUrl}
              target="_blank"
              display="inline-block"
              {...headerLinkSettings}
              onClick={handleSeeMoreDeals}
            >
              {translate(headerLinkKey, 'More Info?')}
            </Link>
          </Col>
        </Row>
      )}
      {showTopDisclaimer && (
        <Box {...topDisclaimerContentSettings}>
          <Disclaimer
            fontSize="3"
            labelKey="cmp-fare-list-container-disclaimer"
            {...topDisclaimer}
          />
        </Box>
      )}
    </>
  );
}

export default HeaderContainer;
